import { FC, ReactNode, useMemo } from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
} from '@mui/material';
import { PopMenu } from '../../../../shared/components/popMenu';
import {
  MachineColumn,
  setColumns,
  setSearchString,
  useColumnNames,
  useColumns,
} from '../../../../core/redux/leftFilterState';
import { translateColumnName } from '../../../../core/helpers/translate';
import { PopMenuHeader } from '../../../../components/popMenuHeader';
import { useDispatch, useSelector } from '../../../../core/hooks/redux';
import { MiniSearch } from '../../../../shared/components/miniSearch';
import { FilterIcon } from '../../../../shared/components/filterIcon';

export const LeftHeader: FC<{
  filters?: ReactNode
}> = ({
  filters,
}) => {
  const mainCatFilter = useSelector((s) => s.leftFilterState.machine.mainCategories);
  const subCatFilter = useSelector((s) => s.leftFilterState.machine.subCategories);
  const sortFilter = useSelector((s) => s.leftFilterState.machine.sortingFilter);
  const managerFilter = useSelector((s) => s.leftFilterState.managers);
  const searchString = useSelector((s) => s.leftFilterState.searchString);

  const filterActive = useMemo(
    () => mainCatFilter.length !== 0
    || subCatFilter.length !== 0
    || sortFilter.length !== 0
    || managerFilter.length !== 0,
    [mainCatFilter, subCatFilter, sortFilter, managerFilter],
  );
  const columns = useColumnNames();
  const activeColumns = useColumns();
  const dispatch = useDispatch();
  const toggleColumn = (column: MachineColumn) => {
    const state = (activeColumns as MachineColumn[]).includes(column);
    if (state) {
      dispatch(setColumns({ machine: (activeColumns as MachineColumn[]).filter((c) => c !== column) }));
    } else {
      dispatch(setColumns({ machine: [...(activeColumns as MachineColumn[]), column] }));
    }
  };

  return (
    <div className="left-header-partial">
      <span className="header-text">
        Kjøretøy
      </span>
      <Box maxWidth={200} width="100%" textAlign="right" pr={2} pl={2}>
        <MiniSearch value={searchString} onChange={(s) => dispatch(setSearchString(s))} />
      </Box>
      <span>
        <Box display="flex" flex={1} gap={3} justifyContent="flex-end">
          <PopMenu
            button={<IconButton><FilterIcon filterActive={filterActive} /></IconButton>}
            width={filters === undefined ? '150px' : '225px'}
          >
            <Box display="flex" flexDirection="column" gap={0.5}>
              {filters !== undefined && (
              <span>
                <PopMenuHeader>Filter</PopMenuHeader>
                {filters}
              </span>
              )}
              <Box>
                <PopMenuHeader>Kolonner</PopMenuHeader>
                {columns.map((column) => (
                  <FormGroup key={column}>
                    <FormControlLabel
                      label={translateColumnName(column)}
                      checked={(activeColumns as MachineColumn[]).includes(column)}
                      onChange={() => { toggleColumn(column); }}
                      disabled={activeColumns.length === 1 && activeColumns.includes(column)}
                      control={<Checkbox />}
                    />
                  </FormGroup>
                ))}
              </Box>
            </Box>
          </PopMenu>
        </Box>
      </span>
    </div>
  );
};
